'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('core-js/modules/es6.symbol.js');
require('core-js/modules/es6.regexp.split.js');
require('core-js/modules/es6.regexp.replace.js');

var CONSUMERS_CHANNEL_SYMBOL = Symbol("CONSUMERS_CHANNEL_SYMBOL");

var channelMap = {};
var getChannelSingleton = function getChannelSingleton(_ref) {
  var key = _ref.key;
  if (!channelMap[key]) {
    channelMap[key] = new MessageChannel();
  }
  return channelMap[key];
};

var getChannel = function getChannel() {
  var _getChannelSingleton = getChannelSingleton({
      key: CONSUMERS_CHANNEL_SYMBOL
    }),
    publicPort = _getChannelSingleton.port1,
    privatePort = _getChannelSingleton.port2;
  return {
    publicPort: publicPort,
    privatePort: privatePort
  };
};

var IFRAME_CHANNEL_SYMBOL = Symbol("IFRAME_CHANNEL_SYMBOL");
var IFRAME_ID = "secure-script-container";
var RECEIVER_URL_TEMPLATE = "https://${containerDomain}/receiver_browse.html";

var getChannel$1 = function getChannel() {
  var _getChannelSingleton = getChannelSingleton({
      key: IFRAME_CHANNEL_SYMBOL
    }),
    localPort = _getChannelSingleton.port1,
    remotePort = _getChannelSingleton.port2;
  return {
    localPort: localPort,
    remotePort: remotePort
  };
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray = _arrayLikeToArray;

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray = _unsupportedIterableToArray;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

var getOriginFromUrl = function getOriginFromUrl(url) {
  var _url$split = url.split("/"),
    _url$split2 = slicedToArray(_url$split, 3),
    scheme = _url$split2[0],
    host = _url$split2[2];
  return "".concat(scheme, "//").concat(host);
};
var loadRemoteAndHandshake = function loadRemoteAndHandshake(_ref) {
  var containerDomain = _ref.containerDomain;
  var iframe = document.querySelector("#".concat(IFRAME_ID));
  var _getChannel = getChannel$1(),
    remotePort = _getChannel.remotePort;
  var receiverUrl = RECEIVER_URL_TEMPLATE.replace(/\${containerDomain}/, containerDomain);
  iframe.onload = function () {
    iframe.contentWindow.postMessage(null, getOriginFromUrl(receiverUrl), [remotePort]);
  };
  iframe.src = receiverUrl;
};

var forwardMessages = function forwardMessages() {
  var _getConsumersChannel = getChannel(),
    privatePort = _getConsumersChannel.privatePort;
  var _getIframeChannel = getChannel$1(),
    localPort = _getIframeChannel.localPort;
  privatePort.onmessage = function (_ref) {
    var data = _ref.data;
    return localPort.postMessage(data);
  };
};

var loadRemoteAndHandshake$1 = function loadRemoteAndHandshake$1(_ref) {
  var containerDomain = _ref.containerDomain;
  forwardMessages();
  loadRemoteAndHandshake({
    containerDomain: containerDomain
  });
};

var getChannel$2 = function getChannel$1() {
  var _getConsumersChannel = getChannel(),
    port = _getConsumersChannel.publicPort;
  return {
    port: port
  };
};

exports.getChannel = getChannel$2;
exports.loadRemoteAndHandshake = loadRemoteAndHandshake$1;
